import { RouteWaypointInsertionMode } from '../protocols/RouteWaypointInsertionMode'
import { SerializableState } from './SerializableState'

export interface SettingsStateProps {
  waypointInsertionMode: RouteWaypointInsertionMode
  cruiseAltitudeSuggesterStatus: 'running' | 'stopped'
}

const INITIAL_STATE: SettingsStateProps = {
  waypointInsertionMode: 'smart',
  cruiseAltitudeSuggesterStatus: 'running'
}

export class SettingsState extends SerializableState<SettingsStateProps> {
  constructor() {
    super(INITIAL_STATE)
  }

  getSetting<K extends keyof SettingsStateProps>(key: K): SettingsStateProps[K] {
    const snapshot = this.getStateSnapshot()
    return snapshot[key]
  }

  setWaypointInsertionMode(waypointInsertionMode: RouteWaypointInsertionMode): void {
    this._updateStateProp('waypointInsertionMode', waypointInsertionMode)
  }

  setCruiseAltitudeSuggesterStatus(cruiseAltitudeSuggesterStatus: 'running' | 'stopped'): void {
    this._updateStateProp('cruiseAltitudeSuggesterStatus', cruiseAltitudeSuggesterStatus)
  }

  getKey(): string {
    return 'settings'
  }
}
